import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

//Components
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';

//Api
import transportador_api from '../../api/transportador_api';

//Helpers
import { showMessage } from '../../helpers/message';
import mascaras from '../../helpers/mascaras';

//Context
import { useAuth } from '../../context/auth';


export default function TransportadoresCredenciados() {
    const { setLoading } = useAuth();
    const navigate = useNavigate();

    //State para pegar os transportadores
    const [listaTransportadores, setListaTransportadores] = useState([]);

    //Cabeçalhos da tabela de listagem de geradores
    const [headersTabela, setHeadersTabela] = useState([
        { value: "Fantasia", objectValue: "fantasia", align: "left" },
        { value: "Razão Social", objectValue: "razaoSocial", align: "left" },
        { value: "Telefone", objectValue: "fone", align: "left" },
        { value: "Modalidades", objectValue: "modalidades", align: "left" }
    ]);

    function loadTransportadoresCredenciados() {
        setLoading(true);
        transportador_api.GetListDisponiveis()
            .then(response => {
                response.data = response.data.map(value => {
                    value.fone = !!value.fone ? mascaras.telefoneMask(value.fone?.replace(/\D+/g, '')) : "";
                    return value
                })
                setListaTransportadores(response.data)
            }).catch(e => {
                showMessage("Erro", e.message, "error", null);
            }).finally(_ => setLoading(false))
    }

    useEffect(() => {
        loadTransportadoresCredenciados();
    }, []);

    return (
        <div>
            <div className='mt-4'>
                <div className=''>
                    <Button className='d-inline   rounded-3 mb-3' onClick={() => navigate(-1)}>
                        <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                    </Button>
                </div>
                <TabelaListagem
                    title="Lista de transportadores credenciados"
                    headers={headersTabela}
                    items={listaTransportadores}
                    options={{
                        print: false,
                        search: true,
                        pagination: true
                    }}
                />
            </div>
        </div>
    )
}
